<template>
    <div class="studio-details">
        <CommonComponentsHomeProductDetails
            :catalogue-list="catalogueList"
            :backcolor="true"
            class="studio-product-details"
        />
    </div>
</template>

<script setup lang="ts">
    import studioVideo1 from '@assets/Video/products/studio/1.mp4';
    import studioPoster1 from '@assets/Video/products/studio/1.jpg';
    import studioVideo2 from '@assets/Video/products/studio/2.mp4';
    import studioPoster2 from '@assets/Video/products/studio/2.jpg';
    import studioVideo3 from '@assets/Video/products/studio/3.mp4';
    import studioPoster3 from '@assets/Video/products/studio/3.jpg';
    import studioVideo4 from '@assets/Video/products/studio/4.mp4';
    import studioPoster4 from '@assets/Video/products/studio/4.jpg';
    import studioVideo5 from '@assets/Video/products/studio/5.mp4';
    import studioPoster5 from '@assets/Video/products/studio/5.jpg';
    import studioVideo6 from '@assets/Video/products/studio/6.mp4';
    import studioPoster6 from '@assets/Video/products/studio/6.jpg';
    import { ifCNLocale } from '@/composables/useLocale.ts';
    import i18n from '@/locales';
    const isCN = ifCNLocale();
    const { t } = i18n.global;

    const catalogueList: Array<CataItem> = [
        {
            categoryText: '',
            itemName: 'global_studio_title_3',
            itemDes: 'global_studio_subTitle_3',
            mediaPath: studioVideo1,
            poster: studioPoster1,
        },
        {
            categoryText: '',
            itemName: 'global_studio_title_4',
            itemDes: 'global_studio_subTitle_4',
            mediaPath: studioVideo2,
            poster: studioPoster2,
        },
        {
            categoryText: '',
            itemName: 'global_studio_title_5',
            itemDes: 'global_studio_subTitle_5',
            mediaPath: studioVideo3,
            poster: studioPoster3,
        },
        {
            categoryText: '',
            itemName: 'global_studio_title_6',
            itemDes: 'global_studio_subTitle_6',
            mediaPath: studioVideo4,
            poster: studioPoster4,
        },
        {
            categoryText: '',
            itemName: 'global_studio_title_7',
            itemDes: 'global_studio_subTitle_7',
            mediaPath: studioVideo5,
            poster: studioPoster5,
        },
        {
            categoryText: '',
            itemName: 'global_studio_title_8',
            itemDes: 'global_studio_subTitle_8',
            mediaPath: studioVideo6,
            poster: studioPoster6,
        },
    ];
</script>

<style lang="less" scoped>
    .studio-details {
        background-color: #000000;
        width: 100%;
        font-family: Montserrat, 'HarmonyOS Sans SC';
        color: #fff;
        :deep(.studio-product-details) {
            margin-top: .convert(132px) [ @vw];
            .home-details-layout-inner {
                padding: .convert(80px) [ @vw] .convert(39px) [ @vw];
                background-color: #262626;
                color: #fff;
            }
            .home-details-grid-container {
                grid-column-gap: .convert(40px) [ @vw];
            }
            .home-details-info-title {
                font-family: 'HarmonyOS Sans SC';
                font-size: .convert(48px) [ @vw] !important;
                font-weight: 400 !important;
                line-height: 140% !important; /* 67.2px */
                @media (max-width: @screen-mobile-width) {
                    font-size: 20px !important;
                }
            }
            .home-details-info-des {
                font-size: .convert(20px) [ @vw] !important;
                @media (max-width: @screen-mobile-width) {
                    font-size: 12px !important;
                }
            }
            .home-details-media-container {
                background-color: #262626;
            }
        }
    }
</style>
